import vid1 from "../../assets/videos/edms-demo-2.mp4";

export const portfolioData = {
    id: 'portfolio',
    lightBg: true,
    lightText: false,
    lightTextDesc: true,
    topLine: 'Portfolio',
    headline: 'Engineering Data Management System',
    description: 'A web application developed for researchers at University of South Australia\'s Future Industries Institute (FII) conducting research on thin film coatings to store, manage & analyse test data. Functionality to upload various tests, sample metadata, export data, database search & filtering, data visualization and more. \nCreated with Django framework.',
    buttonLabel: 'Get started',
    imgStart: false,
    vid: vid1,
    alt: 'edms',
    dark: true,
    primary: true,
    darkText: false
}